<template>
	<div style="height: 100%; position: relative;">
		<div
			id="d009"
			class=""
			style="position: absolute; top: 0; left: 0; right: 0; bottom: 40px;"
		></div>
		<div
			class="center"
			style="position: absolute; bottom: 0; left: 0; right: 0;"
		>
			<span class="dot primary"></span> {{ 'Balansomslutning' | T }}
		</div>
	</div>
</template>

<script>
/* tslint:disable */
import Highcharts from "highcharts";
import Vue from "vue";
import { colors } from "@/config";

export default {
	name: "D009",
	components: {},
	props: {
		balance: Object,
	},

	mounted() {
		this.chart = new Highcharts.chart({
			chart: {
				type: "column",
				renderTo: "d009",
				backgroundColor: "transparent",
			},

			credits: {
				enabled: false,
			},

			title: {
				text: "",
			},

			legend: {
				enabled: false,
			},

			colors: [colors.Primary, colors.Tertiary],

			xAxis: {
				categories: this.balance.sheets
					.map((s) => s.DATE_TO.substr(0, 4))
					.reverse(),
				labels: {
					style: { fontSize: "1rem", color: colors.Black, },
				},
			},

			yAxis: [
				{
					opposite: true,
					allowDecimals: false,
					title: {
						text: "",
					},
					labels: {
						formatter() {
							return Vue.options.filters.KR(this.value);
						},
						style: { fontSize: "1rem", color: colors.DarkGrey },
					},
					tickPixelInterval: 150,
				},
				{
					title: {
						text: Vue.prototype.$t("Soliditet"),
						style: {
							color: colors.Tertiary,
							fontSize: "1.2rem",
						},
					},
					labels: {
						format: "{value} %",
						style: {
							color: colors.Tertiary,
							fontSize: "1.2rem",
						},
					},
					max: 100,
					min: 0,
					tickPixelInterval: 150,
					gridLineColor: colors.Lightgrey,
					plotLines: [{
						color: colors.Black,
						width: 2,
						value: 0,
						zIndex: 2,
					}],
				},
			],

			tooltip: {
				formatter: function() {
					let p = this;
					return this.series.tooltipOptions.tooltip.call(p);
				},
				style: { fontSize: "1.25rem" },
				backgroundColor: colors.Light
			},

			plotOptions: {
				column: {
					stacking: "normal",
					borderColor: colors.DarkGrey,
				},
			},

			series: [
				{
					name: Vue.prototype.$t("Balansomslutning"),
					data: this.balance.sheets
						.map((s, i) =>
							i === 0 ? { y: s.L, color: colors.Secondary } : s.L
						)
						.reverse(),
					tooltip: {
						tooltip: function() {
							return (
								"<b>" +
								this.series.name +
								"<br>" +
								Vue.options.filters.TKR(this.y)
							);
						},
					},
					stack: "intakt",
				},
				{
					name: Vue.prototype.$t("Soliditet"),
					type: "spline",
					yAxis: 1,
					data: this.balance.sheets
						.map((s, i) => (100 * (s.M + 0.78 * s.N)) / s.L)
						.reverse(),
					tooltip: {
						tooltip: function() {
							return (
								"<b>" +
								this.series.name +
								"<br>" +
								Vue.options.filters.D1(this.y) +
								"%"
							);
						},
					},
					dashStyle: "Dash",
				},
			],
		});
	},
};
</script>

<style scoped lang="scss">
.dot {
	height: 20px;
	width: 20px;
	border-radius: 50%;
	display: inline-block;
}

.primary {
	background: linear-gradient(
		-45deg,
		get("colors.Secondary"),
		get("colors.Secondary") 50%,
		get("colors.Primary") 50%
	);
	border-radius: 50%;
}

.result {
	background: linear-gradient(
		-45deg,
		col("colors.Negative"),
		col("colors.Negative") 50%,
		col("colors.Positive") 50%
	);
	border-radius: 50%;
}

.center {
	font-size: 1.2rem;
}
</style>
